import { render, staticRenderFns } from "./Calling.vue?vue&type=template&id=c79b980e&"
import script from "./Calling.vue?vue&type=script&lang=js&"
export * from "./Calling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports